// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pd-0";
export var leftAlign = "_pd-4";
export var listItem = "_pd-2";
export var listItemWrapper = "_pd-1";
export var operationText = "_pd-3";